import React from "react";
import PropTypes from "prop-types";
// import classNames from "classnames";

class TypeFilter extends React.Component {
  render () {
    return (
      <div className="type-filter">
        <label style={{ display: "block", cursor: "pointer" }}>
          <div><b>Show only regulations with numerical standards:</b></div>
          <div className="filter-options">
            <input onClick={this.props.onClick} type="checkbox" checked={this.props.checked} />
          </div>
        </label>
      </div>
    );
  }
}

TypeFilter.propTypes = {
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export { TypeFilter };
